<script setup lang="ts">
import { ChatDotRound } from '@element-plus/icons-vue';

import { useAgentPanel } from './useAgentPanel';

defineProps<{
  collapsed: boolean;
}>();

const { panelOpen, togglePanel } = useAgentPanel();
</script>

<template>
  <button
    type="button"
    class="admin-aside__dock-entry"
    :class="{ 'is-active': panelOpen, 'is-collapsed': collapsed }"
    :title="collapsed ? 'Agent' : undefined"
    aria-label="AI Agent"
    :aria-expanded="panelOpen"
    @click="togglePanel"
  >
    <span class="admin-aside__dock-icon" aria-hidden="true">
      <el-icon><ChatDotRound /></el-icon>
    </span>
    <span v-if="!collapsed" class="admin-aside__dock-label">Agent</span>
  </button>
</template>
